export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/opt/buildhome/repo/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/404',
    name: '/404',
    component: () => import('/opt/buildhome/repo/src/pages/404.vue'),
    /* no children */
  },
  {
    path: '/500',
    name: '/500',
    component: () => import('/opt/buildhome/repo/src/pages/500.vue'),
    /* no children */
  },
  {
    path: '/app',
    /* internal name: '/app' */
    /* no component */
    children: [
      {
        path: ':name',
        name: '/app/[name]',
        component: () => import('/opt/buildhome/repo/src/pages/app/[name].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/report',
    /* internal name: '/report' */
    /* no component */
    children: [
      {
        path: ':name',
        name: '/report/[name]',
        component: () => import('/opt/buildhome/repo/src/pages/report/[name].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/report-validator',
    /* internal name: '/report-validator' */
    /* no component */
    children: [
      {
        path: ':name',
        name: '/report-validator/[name]',
        component: () => import('/opt/buildhome/repo/src/pages/report-validator/[name].vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

